<template>
  <div class="ct-preloader" v-show="this.show">
    <div class="ct-preloader-inner">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Preloader",
  data: function () {
    return {
      show: true,
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log('show loader')
    next(vm => {
      vm.show = true
    });
  },
  beforeResolve(to, from, next) {
    console.log('hide loader')
    next(vm => {
      vm.show = false
    });
  },
  mounted: function () {
    this.$nextTick(function () {
      this.show = false;
    });
  }
}
</script>

<style scoped>
.ct-preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  transition: .3s;
}

.ct-preloader.hidden {
  opacity: 0;
  visibility: hidden;
}
</style>